import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/Index.vue";
// import aspect from "../views/Aspect.vue";
// import explicit from "../views/Explicit.vue";
// import insist from "../views/Insist.vue";
// import achieve from "../views/Achieve.vue";
// import mustInsist from "../views/MustInsist.vue";
// import always from "../views/Always.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect:"/index"
  },
  {
    path: "/index",
    name: "index",
    component: index
  },
  {
    path: "/detail/:id", //接收params传来的id
    name: "detail",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/Detail.vue")
  },
  {
    path: "/aspect/:id", // 五个方面
    name: "aspect",
    component: () =>
        import(/* webpackChunkName: "ImportFunc" */ "../views/Aspect.vue")
  },
  {
    path: "/explicit", // 十个明确
    name: "explicit",
    component: () =>
        import(/* webpackChunkName: "ImportFunc" */ "../views/Explicit.vue")
  },
  {
    path: "/insist", // 十四个坚持
    name: "insist",
    component: () =>
        import(/* webpackChunkName: "ImportFunc" */ "../views/Insist.vue")
  },
  {
    path: "/achieve", // 十三个方面成就
    name: "achieve",
    component: () =>
        import(/* webpackChunkName: "ImportFunc" */ "../views/Achieve.vue")
  },
  {
    path: "/mustInsist", // 六个必须坚持
    name: "mustInsist",
    component: () =>
        import(/* webpackChunkName: "ImportFunc" */ "../views/MustInsist.vue")
  },
  {
    path: "/always", // 六个如何始终
    name: "always",
    component: () =>
        import(/* webpackChunkName: "ImportFunc" */ "../views/Always.vue")
  }
];

const router = new VueRouter({
  //上传服务器用
  // mode:"history", //去除访问地址中# 打包时要注释掉
  // base:"/HistoryCommunistPartyChina_VUE2106/", //如果项目根目录不为域名，则添加该行 外层文件名
  mode: 'hash', // 去掉url中的#
  base: process.env.VUE_APP_VIRTUAL_PATH, // 项目部署子路径配置
  routes
});

//路由不匹配或者路径错误，跳转首页的方法
router.beforeEach((to,from,next)=>{
  if(to.matched.length === 0){//匹配前往的路由不存在
    from.name ? next({
      name: from.name
    }) : next('/index'); //判断此跳转路由的来源路由是否存在，存在就跳转到来源路由，否则跳转首页
  }else{
    next();//如果匹配到正确跳转
  }
});

export default router;
